export function getColumnLetter(index: number): string {
  let column = "";
  while (index > 0) {
    let remainder = (index - 1) % 26;
    column = String.fromCharCode(65 + remainder) + column;
    index = Math.floor((index - 1) / 26);
  }
  return column;
}

export function pascalToSentenceCase(str: string): string {
  return str
      .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
      .trim() // Remove leading space if any
      .replace(/^./, match => match.toUpperCase()); // Capitalize first letter
}

export function id(str: string): string {
  return str.replace(/ /g, '_').replace(/-/g, '_');
}

export function fileName(str: string): string {
  return name(removeFileExtension(str));
}

export function name(str: string): string {
  return capitalize(replaceUnderlines(str));
}

function capitalize(str: string): string {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}

function replaceUnderlines(str: string) {
  return str?.replace(/_/g, ' ');
}

function removeFileExtension(filename: string): string {
  return filename?.replace(/\.[^/.]+$/, "");
}

export function utc(date: Date): Date {
  if (!date) return null;
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12));
}
